import {resource} from '@albert-io/json-api-framework/request/builder';

export const getClassroomsQuery = (teacherId: string, subjectId: string) => {
  return resource('classrooms_v1')
    .mandarkEndpoint(['teachers_v1', teacherId, 'classrooms_v1'])
    .include('subjects_v2')
    .withMeta('subject_v2')
    .withMeta('classroom_v1')
    .sort('name')
    .filter({
      status: 'active',
      included: {
        subjects_v2: subjectId
      }
    });
};
